import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';

export const useUserUtils = () => {
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const isStaffUser = (): boolean => Boolean(user?.is_staff);

  const isSuperUser = (): boolean => Boolean(user?.is_superuser);

  return {
    isStaffUser,
    isSuperUser,
    user,
  };
};
